import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSession } from 'src/commons/hooks';
import { Loading } from '../Loading';


export const PrivateGuard = ({ children }: { children: JSX.Element }) => {
  const { loading, isAuthenticated } = useSession();

  if (loading) return <Loading />;
  if (!isAuthenticated) return <Redirect to="/login" />;

  return children;
};
